import type { StartupProfile } from '../types/firestore';
import { CATALOG_CATEGORY_LABELS, type CatalogCategory } from '../constants/catalog-categories';

export type CatalogBrowsingLists = {
  matchedStartups: StartupProfile[];
  favoriteStartups: StartupProfile[];
  recentlyAddedStartups: StartupProfile[];
  womenLedStartups: StartupProfile[];
  pocOwnedStartups: StartupProfile[];
  lgbtqOwnedStartups: StartupProfile[];
  europeBasedStartups: StartupProfile[];
  usBasedStartups: StartupProfile[];
  latamBasedStartups: StartupProfile[];
  nordicsBasedStartups: StartupProfile[];
  africaBasedStartups: StartupProfile[];
  sdgAlignedStartups: StartupProfile[];
};

/**
 * Best-effort catalog row label for favoriting / URL-open when we don't have an explicit click context.
 * Geography rows are checked before SDG so a startup in both "Europe based" and SDG lists matches Europe.
 */
export function inferCatalogBrowsingCategory(
  startup: StartupProfile,
  lists: CatalogBrowsingLists
): CatalogCategory | undefined {
  const id = startup.id;
  if (!id) return undefined;
  if (lists.matchedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.speciallyForYou;
  if (lists.favoriteStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.yourFavorites;
  if (lists.recentlyAddedStartups.some(s => s.id === id))
    return CATALOG_CATEGORY_LABELS.recentlyAdded;
  if (lists.womenLedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.womenLed;
  if (lists.pocOwnedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.pocOwned;
  if (lists.lgbtqOwnedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.lgbtqOwned;
  if (lists.nordicsBasedStartups.some(s => s.id === id))
    return CATALOG_CATEGORY_LABELS.nordicsBased;
  if (lists.europeBasedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.europeBased;
  if (lists.usBasedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.usBased;
  if (lists.latamBasedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.latamBased;
  if (lists.africaBasedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.africaBased;
  if (lists.sdgAlignedStartups.some(s => s.id === id)) return CATALOG_CATEGORY_LABELS.sdgAligned;
  if (startup.featured) return CATALOG_CATEGORY_LABELS.featuredStartup;
  return CATALOG_CATEGORY_LABELS.moreStartups;
}
